import { useQuery } from '@tanstack/react-query';

import { api } from '../lib/api';
import { formatShortDateTime, prettyJson } from '../lib/format';

/** `user:nik` → `nik`; local entry points get a readable name. */
function actorName(actor: string | null): string {
  if (!actor) return '—';
  if (actor.startsWith('user:')) return actor.slice(5);
  const local: Record<string, string> = {
    'local:web': 'чат в вебе',
    'local:stdio': 'Claude Code',
    'local:script': 'скрипт',
  };
  return local[actor] ?? actor;
}

/** The audit log; a section of Settings (owner only). */
export function AuditSection() {
  const query = useQuery({
    queryKey: ['audit'],
    queryFn: () => api.audit(200),
    refetchInterval: 15_000,
  });

  return (
    <section>
      <h2>Журнал</h2>
      <p className="muted">
        Каждая запись агента (события, встречи, заметки, страницы…), чтения анализов и кто об этом
        попросил. Секреты скрыты.
      </p>

      {query.isPending && <p className="muted">Загрузка…</p>}
      {query.isError && <p className="text-error">{query.error.message}</p>}
      {query.data && !query.data.available && <p className="text-error">База данных недоступна.</p>}
      {query.data?.available && query.data.entries.length === 0 && (
        <div className="card empty">Пока пусто: агент ещё ничего не записывал.</div>
      )}

      {query.data && query.data.entries.length > 0 && (
        <div className="card card--flush">
          <div className="table-scroll">
            <table className="table">
              <thead>
                <tr>
                  <th>Время</th>
                  <th>Инструмент</th>
                  <th>Кто</th>
                  <th>Итог</th>
                  <th>Аргументы</th>
                </tr>
              </thead>
              <tbody>
                {query.data.entries.map((entry) => (
                  <tr key={entry.id}>
                    <td className="nowrap">{formatShortDateTime(entry.at)}</td>
                    <td>
                      <code>{entry.tool}</code>
                    </td>
                    <td className="nowrap small">{actorName(entry.actor)}</td>
                    <td>
                      <span className={`pill pill--${entry.ok ? 'ok' : 'error'}`}>
                        {entry.ok ? 'успех' : 'ошибка'}
                      </span>
                      {entry.error && <div className="text-error small">{entry.error}</div>}
                    </td>
                    <td>
                      <details>
                        <summary className="muted small">показать</summary>
                        <pre>{prettyJson(entry.args)}</pre>
                        {entry.result != null && <pre>{prettyJson(entry.result)}</pre>}
                      </details>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </section>
  );
}
